import { Button, darkThemeClass, styled } from '@streamelements/frontend-ui';
import { forwardRef } from 'react';

const StyledToolbarButton = styled(Button, {
  variants: {
    color: {
      neutral: {},
    },
    variant: {
      ghost: {},
    },
    size: {
      sm: {
        size: '1.125rem',
      },
      default: {
        size: '1.5rem',
      },
    },
    iconButton: {
      true: {
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        borderRadius: '0.25rem',
        padding: 0,
      },
    },
  },
  compoundVariants: [
    {
      color: 'neutral',
      variant: 'ghost',
      css: {
        $$backgroundIdle: '$colors$uiQuaternary',
        $$backgroundHover: '$colors$uiQuaternary',

        [`.${darkThemeClass} &`]: {
          $$backgroundIdle: '$colors$divider',
          $$backgroundHover: '$colors$textPrimary25',
        },

        color: '$textPrimary70',
      },
    },
    {
      iconButton: true,
      size: 'sm',
      css: {
        minHeight: '1.125rem',
      },
    },
  ],

  defaultVariants: {
    size: 'sm',
    iconButton: true,
  },
});

export const ToolbarButton = forwardRef<HTMLButtonElement, React.ComponentProps<typeof StyledToolbarButton>>(
  function ToolbarButton({ children, ...props }, ref) {
    return (
      <StyledToolbarButton {...props} color="neutral" variant="ghost" iconButton ref={ref}>
        {children}
      </StyledToolbarButton>
    );
  }
);
